const securitySettings = {
  "security.change-pin.title": "Change PIN code",
  "security.change-pin.description": "Update your PIN code for secure access.",
  "security.update-password.title": "Update password",
  "security.update-password.description": "Change your account password.",
  
  // Pin setup
  "security.pin-setup.title": "Add Pin code",
  "security.pin-setup.description": "Create a 4-digit pin code to use to quickly switch to your profile",
  "security.pin-setup.confirm-description": "Let's make sure the pin code is correct (re-enter pin code)",
  "security.pin-setup.submit-description": "Submitting Pin",
  "security.pin-setup.mismatch-description": "Pin codes do not match, try again",
  "security.pin-setup.add-description": "Add Pin code",

  "security.pin-setup.success-title": "Pin updated",
  "security.pin-setup.success-description": "Your pin has been set, you can now use it to quickly switch to your profile in VR",

  // Password settings
  "security.password-settings.title": "Update Password",
  "security.password-settings.description": "Enter a new password for your Be Your Best account",
  "security.password-settings.new-password-label": "New Password",
  "security.password-settings.password-length-description": "Must be at least {{ minLength }} characters",
  "security.password-settings.confirm-password-label": "Confirm Password",
  "security.password-settings.password-strength-label": "Password strength:",
  "security.password-settings.passwords-dont-match": "Passwords don't match",
  "security.password-settings.success-title": "Password updated",
  "security.password-settings.strength.too-short": "Too Short",
  "security.password-settings.strength.weak": "Weak",
  "security.password-settings.strength.medium": "Medium",
  "security.password-settings.strength.good": "Good",
  "security.password-settings.strength.strong": "Strong",
};

const securityCheckDialog = {
  "security.check-dialog.title": "Making sure it's you",
  "security.check-dialog.description": "For security, please enter your password to continue",
  "security.check-dialog.password-label": "Password",
  "security.check-dialog.error-message": "Invalid password",
  "security.check-dialog.submit-description": "Submitting password",
}

export const security = {
  ...securitySettings,
  ...securityCheckDialog,
};
